/* ==== Dizionari ==== */
/* NOTA: le stringhe italiane qui sotto sono COPIATE 1:1 dal tuo codice originale */
const I18N = {
  en: {
    page_title: "Questionnaire — Bloating",
    title: "Questionnaire — Bloating",
    hero_title: "Self-assessment for bloating: could a probiotic really help?",
    hero_sub_1: "An informational tool",
    hero_sub_based: "based on",
    hero_sub_link: "clinical guidelines",
    hero_sub_2: "to understand if a probiotic may be indicated for you.",
    hero_credit: "Offered by drdesimone.net and CDS22-formula",

    btn_start: "Start",
    btn_next: "Next",
    btn_back: "Back",
    btn_finish: "Finish",
    btn_print: "Print test results",
    btn_download: "Download",
    btn_back_to_start: "Back to start",

    disclaimer_h2: "Disclaimer & privacy",
    disclaimer_p1: "This questionnaire is for informational and self-assessment purposes only. It does not provide a diagnosis and does not replace medical advice or the advice of other healthcare professionals.",
    disclaimer_p2: "Any decisions regarding <strong>diet</strong>, <strong>lifestyle</strong>, or the <strong>use of supplements/probiotics</strong> should be made <strong>together with your doctor</strong>, especially in the presence of medical conditions, during pregnancy/breastfeeding, or when taking medications.",
    disclaimer_p3: "<strong>Privacy —</strong> This questionnaire runs <strong>entirely in your browser</strong>: <strong>we do not collect, store, track or transmit any data</strong> (personal or answers). Information remains on your device and <strong>disappears</strong> when you close or refresh the page. See our <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a>.",
    disclaimer_accept: "I have read and accept the terms of use of the questionnaire and the information above. I declare that I am at least 18 years old.",

    refs_badge: "References & guidelines",
    refs_title: "Summary of the main sources used",
    refs_notice: "These references support the informational nature of the test, which does not replace consultation with your doctor.",

    alarm_title: "Red flags",
    alarm_note: "If one or more are present, stop the self-assessment and consult your doctor.",
    alarm_none: "No red flags",
    alarm_weight: "Unexplained weight loss",
    alarm_blood: "Blood in stool",
    alarm_fever: "Persistent fever",
    alarm_night: "Nocturnal abdominal pain",
    alarm_age: "Onset after age 50",
    alarm_anemia: "Documented anemia",

    b_title: "Assessment of IBS-characteristic symptoms",
    please_answer_all: "Please answer all questions.",
    ans_yes: "Yes",
    ans_sometimes: "Sometimes",
    ans_no: "No",
    ans_no_menses: "No / I don’t have menses",
    need_help: "Need help?",
    b_q1: "1) After going to the bathroom, does bloating improve?",
    b_q1_help: "Example: abdomen tense before evacuating, less distended afterwards.",
    b_q2: "2) Is bloating associated with diarrhea or constipation?",
    b_q2_help: "On days you are bloated, you go to the bathroom much more or much less than usual, or stools are much looser or much harder.",
    b_q3: "3) On your worst days, are stools looser and/or do you have urgency to go?",
    b_q3_help: "You have to rush to the bathroom and/or stools are unformed.",
    b_q4: "4) Did the problem start after a stomach bug or a course of antibiotics?",
    b_q4_help: "Select “Yes” if symptoms appeared within 3 months of antibiotics or a gastrointestinal infection.",
    b_q5: "5) Does your abdomen swell especially in the evening or after high-FODMAP meals (legumes, onion, sweets, ripe fruit)?",
    b_q5_help: "Notice if bloating worsens in the evening or after large meals or with foods like legumes, onions, fructose-rich fruit, crucifers.",
    b_q6: "6) Have you ever been told you might have irritable bowel syndrome (IBS)?",
    b_q6_help: "Select “Yes” if your doctor suspected irritable bowel syndrome.",

    c_title: "Alternative causes of bloating",
    c_q1: "7) Do you get bloated after milk/dairy (with diarrhea within 1–2 hours)?",
    c_q1_help: "Select “Yes” if after milk/yogurt/ice-cream you generally have bloating and/or diarrhea within a few hours.",
    c_q2: "8) Do you swallow air (e.g., eating fast or carbonated drinks)?",
    c_q2_help: "Select “Yes” if bloating is high-up with frequent belching, especially after fast meals or fizzy drinks.",
    c_q3: "9) Do you have severe constipation (<3 bowel movements/week), without relief after evacuating?",
    c_q3_help: "Select “Yes” if fewer than 3 BMs/week with very hard stools (pellets/lumps) and no relief after.",
    c_q4: "10) Does bloating increase especially on menstrual days?",
    c_q4_help: "In the days preceding or during menses, bloating increases noticeably.",
    c_q5: "11) Do you suspect SIBO: bloating, headache, lightheadedness/brain fog, with very tense abdomen or gas, 1–2 hours after sugary or carb-rich foods (bread, pasta, sweets)?",
    c_q5_help: "Select “Yes” if bloating regularly appears 1–2 hours after bread/pasta/sweets, with very tense abdomen and strong-smelling gas. Consider discussing specific tests with your doctor.",

    res_stop_title: "Warning:",
    res_stop_text: "At least one red flag is present. Stop here and contact your doctor.",
    res_score_label: "Total score:",
    res_fill: "Answer the questions to get the classification.",

    diary_title: "Bloating diary",
    diary_text: "<strong>One minute a day</strong> for clarity. Download the diary, note the essentials and find <strong>what truly works for you</strong>. Useful to track, adjust and discuss with your doctor.",
    survey_title: "Want to help us improve?",
    survey_text: "It takes about 1 minute: complete our brief survey and tell us about your experience.",
    survey_btn: "Go to survey",

    /* Blocchi risultato */
    r_ok_title: "Your profile is compatible with symptoms commonly associated with IBS or an altered gut microbiota.",
    r_ok_meaning_450: "Your answers suggest a microbiota imbalance. A targeted intervention can reduce abdominal tension, irregularity, and urgency.",
    r_ok_steps_450_1: "<strong>Targeted probiotic</strong> – CDS22-<em>formula</em> 450B as indicated.",
    r_ok_steps_450_2: "<strong>Smart nutrition</strong> – gradually reduce high-impact FODMAPs.",
    r_ok_steps_450_3: "<strong>Track progress</strong> – use the Bloating diary.",

    r_ok_meaning_112: "Your answers suggest you may benefit from microbiota support to improve comfort and regularity.",
    r_ok_steps_112_1: "<strong>Daily probiotic</strong> – CDS22-<em>formula</em> 112B as indicated.",
    r_ok_steps_112_2: "<strong>Light FODMAP</strong> – reduce your known triggers (e.g., onion, fizzy drinks, sweets).",
    r_ok_steps_112_3: "<strong>Routine</strong> – hydration, movement, regular schedules.",

    r_mid_title: "You may benefit from a combined approach.",
    r_mid_meaning: "Bloating looks variable: discuss with your doctor to tailor the path.",
    r_mid_steps_1: "<strong>Low-FODMAP diet</strong> – consider a guided path with your doctor (even a “light” version).",
    r_mid_steps_2: "<strong>Habit tweaks</strong> – hydration, slow eating, limit fizzy drinks and known triggers.",
    r_mid_steps_3: "<strong>Ask your doctor</strong> whether a <strong>CDS22-<em>formula</em></strong> course could help.",

    r_low_title: "Your bloating may have specific causes.",
    r_low_meaning: "Score suggests specific factors (lactose, constipation, aerophagia, cycle) driving bloating. Investigate, then target those fronts.",
    r_low_steps_1: "<strong>Observe patterns</strong> – when does it appear (dairy? fast meals? menstrual period?).",
    r_low_steps_2: "<strong>Targeted trials</strong> – 1–2 weeks lactose reduction, slow chewing, limit fizzy drinks, etc.",
    r_low_steps_3: "<strong>If it persists</strong> – discuss specific tests (lactose/SIBO) with your doctor.",

    r_note: "Note: results are informational and do not replace medical advice. Discuss any diet or supplement decisions with your doctor.",
    r_right_title_ok: "May suit you:",
    r_right_title_maybe: "Possible support:",

    /* Prodotti */
    p_450_name: "CDS22-formula 450B",
    p_450_dose: "1 sachet daily · 8–12 weeks",
    p_450_b1: "High bacterial load",
    p_450_b2: "Targeted support in more symptomatic periods",

    p_112_name: "CDS22-formula 112B",
    p_112_dose: "1–2 capsules daily · 8–12 weeks",
    p_112_b1: "Daily use and tolerability",
    p_112_b2: "Microbiota support and post-meal comfort",

    p_badges_array: ["✓ Vegetarian","✓ Preservative-free","✓ Gluten-free","✓ Non-GMO"]
  },

  /* ======= ITALIANO: INVARIATO ======= */
  it: {
    page_title: "Questionario — Pancia gonfia",
    title: "Questionario — Pancia gonfia",
    hero_title: "Test di autovalutazione sul gonfiore: un probiotico può esserti davvero utile?",
    hero_sub_1: "Uno strumento informativo",
    hero_sub_based: "basato su",
    hero_sub_link: "linee guida cliniche",
    hero_sub_2: "per capire se l’uso di un probiotico può essere indicato per te.",
    hero_credit: "Offerto da drdesimone.net e CDS22-formula",

    btn_start: "Inizio",
    btn_next: "Avanti",
    btn_back: "Indietro",
    btn_finish: "Fine",
    btn_print: "Stampa i risultati del test",
    btn_download: "Download",
    btn_back_to_start: "Torna all'inizio",

    disclaimer_h2: "Disclaimer e privacy",
    disclaimer_p1: "Il seguente questionario ha <strong>finalità esclusivamente informative e di auto-valutazione</strong>. <strong>Non fornisce diagnosi</strong> e non sostituisce il parere del medico o di altri operatori sanitari.",
    disclaimer_p2: "Qualsiasi decisione relativa a <strong>dieta</strong>, <strong>stile di vita</strong> o <strong>uso di integratori/probiotici</strong> deve essere presa <strong>insieme al medico curante</strong>, soprattutto in presenza di patologie, in gravidanza/allattamento o in caso di terapie farmacologiche.",
    disclaimer_p3: "<strong>Privacy —</strong> Questo questionario funziona <strong>interamente nel tuo browser</strong>: <strong>non raccogliamo, memorizziamo, tracciamo né trasmettiamo alcun dato</strong> (personale o risposta). Le informazioni restano sul tuo dispositivo e <strong>scompaiono</strong> chiudendo o aggiornando la pagina. Consulta la nostra <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a>.",
    disclaimer_accept: "Ho letto e accetto le condizioni d'uso del questionario e l’informativa sopra riportata. Dichiaro di avere almeno 18 anni.",

    refs_badge: "Riferimenti e linee guida",
    refs_title: "Sintesi delle principali fonti utilizzate",
    refs_notice: "Questi riferimenti supportano l’impostazione informativa del test, che non sostituisce il confronto con il proprio medico.",

    alarm_title: "Presenza di segnali d'allarme",
    alarm_note: "Se uno o più sono presenti, interrompi l’autovalutazione e rivolgiti al medico.",
    alarm_none: "Nessun segnale di allarme",
    alarm_weight: "Perdita di peso non spiegata",
    alarm_blood: "Sangue nelle feci",
    alarm_fever: "Febbre persistente",
    alarm_night: "Dolore addominale notturno",
    alarm_age: "Sintomi insorti dopo i 50 anni",
    alarm_anemia: "Anemia già documentata",

    b_title: "Valutazione dei Sintomi Caratteristici da IBS",
    please_answer_all: "Per favore, rispondi a tutte le domande.",
    ans_yes: "Sì",
    ans_sometimes: "Qualche volta",
    ans_no: "No",
    ans_no_menses: "No / Non ho il ciclo mestruale",
    need_help: "Serve aiuto?",
    b_q1: "1) Dopo essere andato in bagno il gonfiore migliora?",
    b_q1_help: "Esempio: pancia tesa prima di evacuare, più sgonfia dopo.",
    b_q2: "2) Il gonfiore è associato a diarrea o stitichezza?",
    b_q2_help: "Nei giorni in cui sei gonfio/a, ti capita di andare in bagno molto più spesso o molto meno spesso del solito, oppure le feci sono molto molli o molto dure.",
    b_q3: "3) Nei tuoi giorni peggiori hai feci più molli e/o urgenza di andare in bagno?",
    b_q3_help: "Devi correre in bagno e/o le feci non sono formate.",
    b_q4: "4) Il problema è iniziato in seguito a un'influenza intestinale o all'assunzione di antibiotici?",
    b_q4_help: "Seleziona \"Sì\" se i sintomi sono comparsi entro 3 mesi dall'assunzione di antibiotici o da un'influenza intestinale.",
    b_q5: "5) La pancia si gonfia soprattutto la sera o dopo pasti ricchi di FODMAP (legumi, cipolla, dolci, frutta matura)?",
    b_q5_help: "Nota se il gonfiore peggiora la sera o dopo pasti abbondanti oppure con alimenti come legumi, cipolle, frutta ricca di fruttosio, crucifere.",
    b_q6: "6) Ti hanno mai detto che potresti avere la sindrome dell’intestino irritabile (IBS)?",
    b_q6_help: "Seleziona \"Sì\" se il tuo medico ha sospettato che possa trattarsi di intestino irritabile.",

    c_title: "Cause alternative del gonfiore",
    c_q1: "7) Ti gonfi dopo aver assunto latte/latticini (con diarrea entro 1–2 ore)?",
    c_q1_help: "Seleziona “Sì” se nelle ore successive al consumo di latte/yogurt/gelato hai generalmente gonfiore e/o diarrea.",
    c_q2: "8) Ingoi aria (ad es. perché mangi in fretta o bevi bevande gassate)?",
    c_q2_help: "Seleziona \"Sì\" se il gonfiore è localizzato in alto e avverti aria nello stomaco, con frequenti ruttazioni, soprattutto dopo pasti veloci o bevande frizzanti.",
    c_q3: "9) Soffri di stitichezza severa (meno di 3 evacuazioni a settimana), senza sollievo dopo l’evacuazione?",
    c_q3_help: "Seleziona “Sì” se vai in bagno meno di 3 volte a settimana e le feci sono molto dure, a pallini o pezzi compatti, e non ti senti meglio dopo esserti liberato/a.",
    c_q4: "10) Il gonfiore aumenta soprattutto nei giorni del ciclo mestruale?",
    c_q4_help: "Nei giorni che precedono o accompagnano il ciclo mestruale il gonfiore aumenta in maniera particolare.",
    c_q5: "11) Sospetti SIBO, ovvero: accusi gonfiore, mal di testa, senso di stordimento o confusione, con pancia molto tesa o aria, 1–2 ore dopo aver consumato cibi ricchi di zuccheri o carboidrati (pane, pasta, dolci)?",
    c_q5_help: "Seleziona “Sì” se il gonfiore compare regolarmente 1–2 ore dopo aver mangiato pane, pasta o dolci, ed è accompagnato da una pancia molto gonfia e aria con odore intenso. In questi casi può essere utile parlarne col medico per valutare test specifici.",

    res_stop_title: "Attenzione:",
    res_stop_text: "è presente almeno un segnale d’allarme. Interrompi qui e contatta il medico.",
    res_score_label: "Punteggio totale:",
    res_fill: "Compila le domande per ottenere la classificazione.",

    diary_title: "Diario del gonfiore",
    diary_text: "<strong>Un minuto al giorno</strong> per trasformare la confusione in chiarezza. Scarica il diario, annota l’essenziale e capisci <strong>che cosa funziona davvero per te</strong>. Utile per imparare a conoscerti meglio, tenere traccia, aggiustare il percorso e per parlare con il tuo medico partendo dai fatti.",
    survey_title: "Vuoi aiutarci a migliorare?",
    survey_text: "Basta circa 1 minuto: compila il nostro breve sondaggio e raccontaci la tua esperienza.",
    survey_btn: "Vai al sondaggio",

    r_ok_title: "Il tuo profilo è compatibile con sintomi comunemente associati a IBS o a un'alterazione del microbiota intestinale.",
    r_ok_meaning_450: "Il pattern delle risposte suggerisce un’alterazione del microbiota intestinale. Un intervento mirato può ridurre tensione addominale, irregolarità e urgenza.",
    r_ok_steps_450_1: "<strong>Probiotico mirato</strong> – CDS22-<em>formula</em> 450B come indicato.",
    r_ok_steps_450_2: "<strong>Alimentazione consapevole</strong> – riduci gradualmente i FODMAP ad alto impatto.",
    r_ok_steps_450_3: "<strong>Monitora i progressi</strong> – compila il Diario del gonfiore.",

    r_ok_meaning_112: "Le risposte indicano che potresti beneficiare di un supporto al microbiota per migliorare comfort e regolarità.",
    r_ok_steps_112_1: "<strong>Probiotico quotidiano</strong> – CDS22-<em>formula</em> 112B come indicato.",
    r_ok_steps_112_2: "<strong>FODMAP “light”</strong> – riduci i trigger che riconosci (ad es. cipolla, bevande gassate, dolci).",
    r_ok_steps_112_3: "<strong>Routine intestinale</strong> – idratazione, movimento e orari regolari.",

    r_mid_title: "Potresti trarre beneficio da un approccio combinato.",
    r_mid_meaning: "Il gonfiore appare variabile: confrontati con il tuo medico per capire il percorso più adatto.",
    r_mid_steps_1: "<strong>Dieta a basso contenuto di FODMAP</strong> – valuta <em>insieme al medico</em> se iniziare un percorso guidato (anche solo in versione “light”).",
    r_mid_steps_2: "<strong>Piccole correzioni delle abitudini</strong> – idratazione, pasti regolari, mangiare lentamente, limitare bevande gassate e i trigger che riconosci.",
    r_mid_steps_3: "<strong>Chiedi al medico</strong> se ritiene utile un intervento con <strong>CDS22-<em>formula</em></strong> (scelta e durata dipendono dalla valutazione clinica).",

    r_low_title: "Il tuo gonfiore potrebbe avere cause specifiche.",
    r_low_meaning: "Il punteggio fa pensare che sussistano fattori specifici (lattosio, stipsi, aerofagia, ciclo) che ti provocano gonfiore. Conviene indagare, e poi intervenire su quei fronti.",
    r_low_steps_1: "<strong>Osserva i pattern</strong> – quando compare (latticini? pasti veloci? periodo mestruale?).",
    r_low_steps_2: "<strong>Piccole prove mirate</strong> – riduci lattosio 1–2 settimane, mastica lentamente, limita bevande gassate, ecc.",
    r_low_steps_3: "<strong>Se persiste</strong> – valuta con il medico test mirati (lattosio/SIBO).",

    r_note: "Nota: i risultati hanno finalità informative e non sostituiscono il parere del medico. Valuta ogni decisione su dieta o integratori insieme al tuo medico.",
    r_right_title_ok: "Potrebbe fare per te:",
    r_right_title_maybe: "Possibile supporto:",

    p_450_name: "CDS22-formula 450B",
    p_450_dose: "1 bustina al giorno · 8–12 settimane",
    p_450_b1: "Carica batterica elevata",
    p_450_b2: "Supporto mirato nei periodi più sintomatici",

    p_112_name: "CDS22-formula 112B",
    p_112_dose: "1–2 capsule al giorno · 8–12 settimane",
    p_112_b1: "Uso quotidiano e tollerabilità",
    p_112_b2: "Supporto del microbiota e comfort post-pasto",

    p_badges_array: ["✓ Vegetarian","✓ Preservative-free","✓ Gluten-free","✓ Non-GMO"]
  },

  /* ======= ESPAÑOL ======= */
  es: {
    page_title: "Cuestionario — Distensión abdominal",
    title: "Cuestionario — Distensión abdominal",
    hero_title: "Autoevaluación sobre hinchazón: ¿un probiótico podría ayudarte de verdad?",
    hero_sub_1: "Una herramienta informativa",
    hero_sub_based: "basada en",
    hero_sub_link: "guías clínicas",
    hero_sub_2: "para entender si un probiótico puede estar indicado para ti.",
    hero_credit: "Ofrecido por drdesimone.net y CDS22-formula",

    btn_start: "Empezar",
    btn_next: "Siguiente",
    btn_back: "Atrás",
    btn_finish: "Finalizar",
    btn_print: "Imprimir resultados",
    btn_download: "Descargar",
    btn_back_to_start: "Volver al inicio",

    disclaimer_h2: "Aviso y privacidad",
    disclaimer_p1: "Este cuestionario tiene fines exclusivamente informativos y de autoevaluación; no proporciona un diagnóstico ni sustituye el consejo médico.",
    disclaimer_p2: "Cualquier decisión sobre <strong>dieta</strong>, <strong>estilo de vida</strong> o <strong>uso de suplementos/probióticos</strong> debe tomarse <strong>junto con tu médico</strong>, especialmente en caso de patologías, embarazo/lactancia o tratamientos farmacológicos.",
    disclaimer_p3: "<strong>Privacidad —</strong> Este cuestionario funciona <strong>enteramente en tu navegador</strong>: <strong>no recopilamos, almacenamos, rastreamos ni transmitimos datos</strong> (personales o respuestas). La información permanece en tu dispositivo y <strong>desaparece</strong> al cerrar o actualizar la página. Consulta nuestra <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Política de privacidad</a>.",
    disclaimer_accept: "He leído y acepto las condiciones de uso del cuestionario y la información anterior. Declaro ser mayor de 18 años.",

    refs_badge: "Referencias y guías",
    refs_title: "Resumen de las principales fuentes utilizadas",
    refs_notice: "Estas referencias respaldan el carácter informativo de la prueba; no sustituyen la consulta con tu médico.",

    alarm_title: "Signos de alarma",
    alarm_note: "Si hay uno o más, detén la autoevaluación y consulta a tu médico.",
    alarm_none: "Sin signos de alarma",
    alarm_weight: "Pérdida de peso inexplicada",
    alarm_blood: "Sangre en las heces",
    alarm_fever: "Fiebre persistente",
    alarm_night: "Dolor abdominal nocturno",
    alarm_age: "Inicio de síntomas después de los 50 años",
    alarm_anemia: "Anemia documentada",

    b_title: "Evaluación de síntomas característicos de SII",
    please_answer_all: "Por favor, responde a todas las preguntas.",
    ans_yes: "Sí",
    ans_sometimes: "A veces",
    ans_no: "No",
    ans_no_menses: "No / No tengo menstruación",
    need_help: "¿Necesitas ayuda?",
    b_q1: "1) ¿Mejora la hinchazón después de ir al baño?",
    b_q1_help: "Ejemplo: abdomen tenso antes de evacuar, menos distendido después.",
    b_q2: "2) ¿La hinchazón se asocia a diarrea o estreñimiento?",
    b_q2_help: "En los días con hinchazón, vas al baño mucho más o mucho menos de lo habitual, o las heces son mucho más blandas o más duras.",
    b_q3: "3) En tus peores días, ¿tienes heces más blandas y/o urgencia para defecar?",
    b_q3_help: "Necesidad de ir corriendo al baño y/o heces no formadas.",
    b_q4: "4) ¿El problema empezó tras una gastroenteritis o antibióticos?",
    b_q4_help: "Selecciona “Sí” si los síntomas aparecieron en los 3 meses posteriores a antibióticos o infección gastrointestinal.",
    b_q5: "5) ¿Se hincha más el abdomen por la tarde o tras comidas ricas en FODMAP (legumbres, cebolla, dulces, fruta madura)?",
    b_q5_help: "Observa si empeora por la tarde o tras comidas abundantes o con legumbres, cebolla, fruta rica en fructosa, crucíferas.",
    b_q6: "6) ¿Alguna vez te han dicho que podrías tener síndrome de intestino irritable (SII)?",
    b_q6_help: "Selecciona “Sí” si tu médico lo ha sospechado.",

    c_title: "Causas alternativas de la hinchazón",
    c_q1: "7) ¿Te hinchas tras leche/lácteos (con diarrea en 1–2 horas)?",
    c_q1_help: "Selecciona “Sí” si tras leche/yogur/helado sueles presentar hinchazón y/o diarrea.",
    c_q2: "8) ¿Tragas aire (p. ej., comes rápido o bebes carbonatadas)?",
    c_q2_help: "Selecciona “Sí” si la hinchazón es alta con eructos frecuentes, sobre todo tras comidas rápidas o bebidas con gas.",
    c_q3: "9) ¿Estreñimiento severo (menos de 3 deposiciones/semana) sin alivio tras evacuar?",
    c_q3_help: "Selecciona “Sí” si vas al baño <3/semana, heces muy duras (bolitas/trozos) y sin alivio posterior.",
    c_q4: "10) ¿Aumenta la hinchazón en los días de menstruación?",
    c_q4_help: "En los días previos o durante la menstruación la hinchazón aumenta notablemente.",
    c_q5: "11) ¿Sospechas SIBO: hinchazón, cefalea, aturdimiento o ‘niebla mental’, con abdomen muy tenso o gases, 1–2 h tras azúcares o carbohidratos (pan, pasta, dulces)?",
    c_q5_help: "Selecciona “Sí” si aparece 1–2 h tras pan/pasta/dulces, con abdomen muy hinchado y gases de olor intenso. Consulta con tu médico sobre pruebas específicas.",

    res_stop_title: "Atención:",
    res_stop_text: "Hay al menos un signo de alarma. Detén aquí y consulta a tu médico.",
    res_score_label: "Puntuación total:",
    res_fill: "Responde para obtener la clasificación.",

    diary_title: "Diario de hinchazón",
    diary_text: "<strong>Un minuto al día</strong> para pasar de la confusión a la claridad. Descarga el diario, anota lo esencial y descubre <strong>qué te funciona</strong>.",
    survey_title: "¿Nos ayudas a mejorar?",
    survey_text: "Solo 1 minuto: completa nuestra breve encuesta y cuéntanos tu experiencia.",
    survey_btn: "Ir a la encuesta",

    r_ok_title: "Tu perfil es compatible con síntomas frecuentemente asociados al SII o a un desequilibrio del microbiota intestinal.",
    r_ok_meaning_450: "Tus respuestas sugieren un desequilibrio del microbiota. Una intervención dirigida puede reducir tensión abdominal, irregularidad y urgencia.",
    r_ok_steps_450_1: "<strong>Probiótico dirigido</strong> – CDS22-<em>formula</em> 450B según indicación.",
    r_ok_steps_450_2: "<strong>Nutrición inteligente</strong> – reduce gradualmente los FODMAP de alto impacto.",
    r_ok_steps_450_3: "<strong>Controla los progresos</strong> – usa el Diario de hinchazón.",

    r_ok_meaning_112: "Puedes beneficiarte de apoyo al microbiota para mejorar confort y regularidad.",
    r_ok_steps_112_1: "<strong>Probiótico diario</strong> – CDS22-<em>formula</em> 112B según indicación.",
    r_ok_steps_112_2: "<strong>FODMAP “light”</strong> – reduce desencadenantes conocidos (cebolla, bebidas con gas, dulces).",
    r_ok_steps_112_3: "<strong>Rutina</strong> – hidratación, movimiento, horarios regulares.",

    r_mid_title: "Puede ayudarte un enfoque combinado.",
    r_mid_meaning: "La hinchazón es variable: coméntalo con tu médico para ajustar el plan.",
    r_mid_steps_1: "<strong>Dieta baja en FODMAP</strong> – valora un plan guiado con tu médico (incluso “light”).",
    r_mid_steps_2: "<strong>Hábitos</strong> – hidratación, comer despacio, limitar bebidas con gas y desencadenantes.",
    r_mid_steps_3: "<strong>Consulta</strong> si un curso con <strong>CDS22-<em>formula</em></strong> podría ayudar.",

    r_low_title: "Tu hinchazón puede tener causas específicas.",
    r_low_meaning: "La puntuación sugiere factores concretos (lactosa, estreñimiento, aerofagia, ciclo). Investiga y actúa sobre ellos.",
    r_low_steps_1: "<strong>Observa patrones</strong> – ¿cuándo aparece (lácteos, comidas rápidas, menstruación)?",
    r_low_steps_2: "<strong>Pruebas dirigidas</strong> – 1–2 semanas menos lactosa, masticar despacio, limitar bebidas con gas…",
    r_low_steps_3: "<strong>Si persiste</strong> – habla con tu médico sobre pruebas (lactosa/SIBO).",

    r_note: "Nota: los resultados son informativos y no sustituyen el consejo médico.",
    r_right_title_ok: "Puede encajar contigo:",
    r_right_title_maybe: "Apoyo posible:",

    p_450_name: "CDS22-formula 450B",
    p_450_dose: "1 sobre al día · 8–12 semanas",
    p_450_b1: "Alta carga bacteriana",
    p_450_b2: "Apoyo dirigido en periodos sintomáticos",

    p_112_name: "CDS22-formula 112B",
    p_112_dose: "1–2 cápsulas al día · 8–12 semanas",
    p_112_b1: "Uso diario y tolerabilidad",
    p_112_b2: "Apoyo al microbiota y confort postprandial",

    p_badges_array: ["✓ Vegetariano","✓ Sin conservantes","✓ Sin gluten","✓ No OGM"]
  },

  /* ======= FRANÇAIS ======= */
  fr: {
    page_title: "Questionnaire — Ballonnements",
    title: "Questionnaire — Ballonnements",
    hero_title: "Auto-évaluation des ballonnements : un probiotique peut-il vraiment vous aider ?",
    hero_sub_1: "Un outil informatif",
    hero_sub_based: "fondé sur des",
    hero_sub_link: "recommandations cliniques",
    hero_sub_2: "pour savoir si un probiotique peut être indiqué pour vous.",
    hero_credit: "Proposé par drdesimone.net et CDS22-formula",

    btn_start: "Commencer",
    btn_next: "Suivant",
    btn_back: "Retour",
    btn_finish: "Terminer",
    btn_print: "Imprimer les résultats",
    btn_download: "Télécharger",
    btn_back_to_start: "Retour au début",

    disclaimer_h2: "Avertissement et confidentialité",
    disclaimer_p1: "Ce questionnaire a une finalité exclusivement informative et d’auto-évaluation ; il ne fournit pas de diagnostic et ne remplace pas l’avis médical.",
    disclaimer_p2: "Toute décision relative au <strong>régime</strong>, au <strong>mode de vie</strong> ou à l’<strong>usage de compléments/probiotiques</strong> doit être prise <strong>avec votre médecin</strong>, notamment en cas de pathologie, de grossesse/allaitement ou de traitement.",
    disclaimer_p3: "<strong>Confidentialité —</strong> Ce questionnaire fonctionne <strong>entièrement dans votre navigateur</strong> : <strong>nous ne recueillons, ne stockons, ne suivons ni ne transmettons aucune donnée</strong>. Les informations restent sur votre appareil et <strong>disparaissent</strong> en fermant/actualisant la page. Voir notre <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Politique de confidentialité</a>.",
    disclaimer_accept: "J’ai lu et j’accepte les conditions d’utilisation ci-dessus. Je déclare être âgé d’au moins 18 ans.",

    refs_badge: "Références et recommandations",
    refs_title: "Synthèse des principales sources utilisées",
    refs_notice: "Ces références appuient la finalité informative du test, qui ne remplace pas l’avis de votre médecin.",

    alarm_title: "Signes d’alerte",
    alarm_note: "S’il y en a un ou plusieurs, arrêtez l’auto-évaluation et consultez votre médecin.",
    alarm_none: "Aucun signe d’alerte",
    alarm_weight: "Perte de poids inexpliquée",
    alarm_blood: "Sang dans les selles",
    alarm_fever: "Fièvre persistante",
    alarm_night: "Douleur abdominale nocturne",
    alarm_age: "Début après 50 ans",
    alarm_anemia: "Anémie documentée",

    b_title: "Évaluation des symptômes caractéristiques du SII",
    please_answer_all: "Veuillez répondre à toutes les questions.",
    ans_yes: "Oui",
    ans_sometimes: "Parfois",
    ans_no: "Non",
    ans_no_menses: "Non / Pas de menstruations",
    need_help: "Besoin d’aide ?",
    b_q1: "1) Après être allé aux toilettes, les ballonnements s’améliorent-ils ?",
    b_q1_help: "Exemple : abdomen tendu avant d’évacuer, moins distendu après.",
    b_q2: "2) Les ballonnements sont-ils associés à diarrhée ou constipation ?",
    b_q2_help: "Les jours de ballonnements, vous allez beaucoup plus ou beaucoup moins souvent à la selle, ou les selles sont beaucoup plus molles/durcies.",
    b_q3: "3) Les pires jours, avez-vous des selles plus molles et/ou une urgence à aller à la selle ?",
    b_q3_help: "Besoin pressant d’aller aux toilettes et/ou selles non formées.",
    b_q4: "4) Le problème a-t-il débuté après une gastroentérite ou des antibiotiques ?",
    b_q4_help: "Sélectionnez « Oui » si les symptômes sont apparus dans les 3 mois.",
    b_q5: "5) Abdomen plus gonflé le soir ou après des repas riches en FODMAP (légumineuses, oignon, sucreries, fruits mûrs) ?",
    b_q5_help: "Observez si cela s’accentue le soir ou après des repas copieux / aliments déclencheurs.",
    b_q6: "6) Vous a-t-on déjà évoqué un syndrome de l’intestin irritable (SII) ?",
    b_q6_help: "Sélectionnez « Oui » si votre médecin l’a suspecté.",

    c_title: "Causes alternatives des ballonnements",
    c_q1: "7) Ballonnements après lait/laitages (avec diarrhée en 1–2 h) ?",
    c_q1_help: "Sélectionnez « Oui » si après lait/yaourt/glace vous avez ballonnements et/ou diarrhée.",
    c_q2: "8) Avalez-vous de l’air (repas rapides, boissons gazeuses) ?",
    c_q2_help: "« Oui » si ballonnements hauts avec éructations fréquentes, surtout après repas rapides / boissons gazeuses.",
    c_q3: "9) Constipation sévère (<3 selles/sem.) sans soulagement après évacuation ?",
    c_q3_help: "« Oui » si <3/sem., selles très dures (fécalomes/granuleuses) et pas de soulagement.",
    c_q4: "10) Ballonnements surtout pendant les règles ?",
    c_q4_help: "Aggravation notable avant ou pendant les menstruations.",
    c_q5: "11) Suspicion de SIBO : ballonnements, céphalées, étourdissements/“brouillard”, abdomen très tendu ou gaz, 1–2 h après sucres/glucides (pain, pâtes, desserts) ?",
    c_q5_help: "« Oui » si cela survient 1–2 h après pain/pâtes/desserts, avec gaz odorants. Parlez-en à votre médecin.",

    res_stop_title: "Attention :",
    res_stop_text: "Au moins un signe d’alerte est présent. Arrêtez-vous ici et contactez votre médecin.",
    res_score_label: "Score total :",
    res_fill: "Répondez pour obtenir la classification.",

    diary_title: "Journal des ballonnements",
    diary_text: "<strong>Une minute par jour</strong> pour y voir clair. Téléchargez le journal, notez l’essentiel et découvrez <strong>ce qui vous aide</strong>.",
    survey_title: "Aidez-nous à nous améliorer ?",
    survey_text: "Environ 1 minute : répondez à notre bref sondage et partagez votre expérience.",
    survey_btn: "Aller au sondage",

    r_ok_title: "Votre profil est compatible avec des symptômes souvent associés au SII ou à un déséquilibre du microbiote intestinal.",
    r_ok_meaning_450: "Vos réponses suggèrent un déséquilibre du microbiote. Une intervention ciblée peut réduire la tension abdominale, l’irrégularité et l’urgence.",
    r_ok_steps_450_1: "<strong>Probiotique ciblé</strong> – CDS22-<em>formula</em> 450B selon indication.",
    r_ok_steps_450_2: "<strong>Alimentation raisonnée</strong> – réduire progressivement les FODMAP à fort impact.",
    r_ok_steps_450_3: "<strong>Suivi</strong> – utilisez le journal des ballonnements.",

    r_ok_meaning_112: "Un soutien du microbiote peut améliorer confort et régularité.",
    r_ok_steps_112_1: "<strong>Probiotique quotidien</strong> – CDS22-<em>formula</em> 112B selon indication.",
    r_ok_steps_112_2: "<strong>FODMAP « light »</strong> – limiter vos déclencheurs connus.",
    r_ok_steps_112_3: "<strong>Routine</strong> – hydratation, activité, régularité.",

    r_mid_title: "Un abord combiné peut vous aider.",
    r_mid_meaning: "Variabilité des ballonnements : ajustez avec votre médecin.",
    r_mid_steps_1: "<strong>Régime pauvre en FODMAP</strong> – idéalement encadré.",
    r_mid_steps_2: "<strong>Habitudes</strong> – boire, manger lentement, limiter boissons gazeuses et déclencheurs.",
    r_mid_steps_3: "<strong>Évaluez</strong> l’intérêt d’un <strong>CDS22-<em>formula</em></strong>.",

    r_low_title: "Vos ballonnements peuvent avoir des causes spécifiques.",
    r_low_meaning: "Facteurs possibles : lactose, constipation, aérophagie, cycle. À investiguer puis cibler.",
    r_low_steps_1: "<strong>Observer</strong> – quand cela survient (laitages, repas rapides, menstruations).",
    r_low_steps_2: "<strong>Essais ciblés</strong> – 1–2 sem. pauvre en lactose, mâcher lentement, limiter boissons gazeuses.",
    r_low_steps_3: "<strong>Si persistant</strong> – discutez test lactose/SIBO avec votre médecin.",

    r_note: "Note : ces résultats sont informatifs et ne remplacent pas l’avis médical.",
    r_right_title_ok: "Peut vous convenir :",
    r_right_title_maybe: "Soutien possible :",

    p_450_name: "CDS22-formula 450B",
    p_450_dose: "1 sachet par jour · 8–12 semaines",
    p_450_b1: "Charge bactérienne élevée",
    p_450_b2: "Soutien ciblé en périodes symptomatiques",

    p_112_name: "CDS22-formula 112B",
    p_112_dose: "1–2 gélules par jour · 8–12 semaines",
    p_112_b1: "Usage quotidien et tolérance",
    p_112_b2: "Soutien du microbiote et confort post-prandial",

    p_badges_array: ["✓ Végétarien","✓ Sans conservateurs","✓ Sans gluten","✓ Sans OGM"]
  },

  /* ======= DEUTSCH ======= */
  de: {
    page_title: "Fragebogen — Blähbauch",
    title: "Fragebogen — Blähbauch",
    hero_title: "Selbsteinschätzung bei Blähbauch: Könnte ein Probiotikum wirklich helfen?",
    hero_sub_1: "Ein Informations-Tool",
    hero_sub_based: "basierend auf",
    hero_sub_link: "klinischen Leitlinien",
    hero_sub_2: "um zu verstehen, ob ein Probiotikum für dich geeignet sein könnte.",
    hero_credit: "Angeboten von drdesimone.net und CDS22-formula",

    btn_start: "Start",
    btn_next: "Weiter",
    btn_back: "Zurück",
    btn_finish: "Fertig",
    btn_print: "Testergebnisse drucken",
    btn_download: "Download",
    btn_back_to_start: "Zurück zum Anfang",

    disclaimer_h2: "Hinweis & Datenschutz",
    disclaimer_p1: "Dieser Fragebogen dient ausschließlich Informations- und Selbsteinschätzungszwecken; er stellt keine Diagnose und ersetzt keine ärztliche Beratung.",
    disclaimer_p2: "Entscheidungen zu <strong>Ernährung</strong>, <strong>Lebensstil</strong> oder <strong>Einsatz von Supplementen/Probiotika</strong> sollten <strong>gemeinsam mit deinem Arzt</strong> getroffen werden, insbesondere bei Vorerkrankungen, Schwangerschaft/Stillzeit oder Medikamenteneinnahme.",
    disclaimer_p3: "<strong>Datenschutz —</strong> Dieses Tool läuft <strong>vollständig in deinem Browser</strong>: <strong>Wir erheben, speichern, tracken oder übertragen keine Daten</strong>. Informationen verbleiben auf deinem Gerät und <strong>verschwinden</strong> beim Schließen/Aktualisieren. Siehe unsere <a href=\"/policies/privacy-policy\" target=\"_blank\" rel=\"noopener\">Datenschutzerklärung</a>.",
    disclaimer_accept: "Ich habe die Nutzungsbedingungen gelesen und akzeptiere sie und erkläre, mindestens 18 Jahre alt zu sein.",

    refs_badge: "Referenzen & Leitlinien",
    refs_title: "Zusammenfassung der verwendeten Hauptquellen",
    refs_notice: "Diese Referenzen untermauern den Informationscharakter des Tests und ersetzen nicht die ärztliche Beratung.",

    alarm_title: "Warnzeichen",
    alarm_note: "Wenn eines oder mehrere vorliegen, die Selbsteinschätzung stoppen und den Arzt kontaktieren.",
    alarm_none: "Keine Warnzeichen",
    alarm_weight: "Unerklärter Gewichtsverlust",
    alarm_blood: "Blut im Stuhl",
    alarm_fever: "Anhaltendes Fieber",
    alarm_night: "Nächtliche Bauchschmerzen",
    alarm_age: "Beginn nach dem 50. Lebensjahr",
    alarm_anemia: "Nachgewiesene Anämie",

    b_title: "Bewertung IBS-typischer Symptome",
    please_answer_all: "Bitte beantworte alle Fragen.",
    ans_yes: "Ja",
    ans_sometimes: "Manchmal",
    ans_no: "Nein",
    ans_no_menses: "Nein / keine Menstruation",
    need_help: "Brauchst du Hilfe?",
    b_q1: "1) Wird der Blähbauch nach dem Toilettengang besser?",
    b_q1_help: "Beispiel: Bauch vor dem Stuhlgang gespannt, danach weniger aufgebläht.",
    b_q2: "2) Tritt die Aufblähung zusammen mit Durchfall oder Verstopfung auf?",
    b_q2_help: "An Blähtagen gehst du viel häufiger oder seltener zur Toilette; der Stuhl ist sehr weich oder sehr hart.",
    b_q3: "3) An schlechten Tagen: weichere Stühle und/oder Entleerungsdrang?",
    b_q3_help: "Du musst eilig zur Toilette und/oder der Stuhl ist ungeformt.",
    b_q4: "4) Begann das Problem nach Magen-Darm-Infekt oder Antibiotika?",
    b_q4_help: "„Ja“, wenn die Beschwerden innerhalb von 3 Monaten nach Antibiotika oder GI-Infekt auftraten.",
    b_q5: "5) Abends stärkerer Blähbauch oder nach FODMAP-reichen Mahlzeiten (Hülsenfrüchte, Zwiebel, Süßes, reifes Obst)?",
    b_q5_help: "Achte auf Verstärkung abends oder nach großen Mahlzeiten / genannten Lebensmitteln.",
    b_q6: "6) Wurde dir schon einmal ein Reizdarmsyndrom (IBS) nahegelegt?",
    b_q6_help: "„Ja“, wenn dein Arzt ein Reizdarm vermutet hat.",

    c_title: "Alternative Ursachen der Aufblähung",
    c_q1: "7) Blähbauch nach Milch/Milchprodukten (mit Durchfall nach 1–2 Std.)?",
    c_q1_help: "„Ja“, wenn nach Milch/Joghurt/Eis häufig Blähbauch und/oder Durchfall auftreten.",
    c_q2: "8) Schluckst du Luft (z. B. schnelles Essen, kohlensäurehaltige Getränke)?",
    c_q2_help: "„Ja“, wenn Oberbauch-Luft/ häufiges Aufstoßen, v. a. nach schnellen Mahlzeiten/ Sprudel.",
    c_q3: "9) Schwere Obstipation (<3 Stuhlgänge/Woche) ohne Erleichterung nach Entleerung?",
    c_q3_help: "„Ja“, wenn <3/Woche, sehr harter Stuhl (Kügelchen/Klumpen), ohne Besserung danach.",
    c_q4: "10) Zunahme der Aufblähung vor/während der Menstruation?",
    c_q4_help: "Deutlich stärker in den Tagen rund um die Menstruation.",
    c_q5: "11) Verdacht auf SIBO: Blähbauch, Kopfschmerz, Benommenheit/„brain fog“, sehr gespannter Bauch oder Gas 1–2 Std. nach Zucker/Kohlenhydraten (Brot, Pasta, Süßes)?",
    c_q5_help: "„Ja“, wenn 1–2 Std. nach Brot/Pasta/Süßem regelmäßig stark aufgebläht mit übelriechenden Gasen. Ärztlich Tests erwägen.",

    res_stop_title: "Achtung:",
    res_stop_text: "Mindestens ein Warnzeichen liegt vor. Hier stoppen und den Arzt kontaktieren.",
    res_score_label: "Gesamtpunktzahl:",
    res_fill: "Beantworte die Fragen, um die Einstufung zu erhalten.",

    diary_title: "Blähbauch-Tagebuch",
    diary_text: "<strong>Eine Minute täglich</strong> für Klarheit. Lade das Tagebuch herunter, notiere das Wesentliche und finde <strong>was dir hilft</strong>.",
    survey_title: "Hilf uns, besser zu werden",
    survey_text: "Rund 1 Minute: kurze Umfrage ausfüllen und Erfahrung teilen.",
    survey_btn: "Zur Umfrage",

    r_ok_title: "Dein Profil passt zu Symptomen, die häufig mit IBS oder einem Mikrobiota-Ungleichgewicht einhergehen.",
    r_ok_meaning_450: "Deine Antworten deuten auf ein Mikrobiota-Ungleichgewicht hin. Eine gezielte Intervention kann Druckgefühl, Unregelmäßigkeit und Drang mindern.",
    r_ok_steps_450_1: "<strong>Gezieltes Probiotikum</strong> – CDS22-<em>formula</em> 450B gemäß Angabe.",
    r_ok_steps_450_2: "<strong>Ernährung anpassen</strong> – schrittweise FODMAPs mit hohem Einfluss reduzieren.",
    r_ok_steps_450_3: "<strong>Verlauf dokumentieren</strong> – Tagebuch nutzen.",

    r_ok_meaning_112: "Du könntest von Mikrobiota-Unterstützung für Komfort und Regelmäßigkeit profitieren.",
    r_ok_steps_112_1: "<strong>Tägliches Probiotikum</strong> – CDS22-<em>formula</em> 112B gemäß Angabe.",
    r_ok_steps_112_2: "<strong>„Leicht“ FODMAP</strong> – bekannte Trigger begrenzen (Zwiebel, Sprudel, Süßes).",
    r_ok_steps_112_3: "<strong>Routine</strong> – Hydration, Bewegung, Regelmäßigkeit.",

    r_mid_title: "Ein kombinierter Ansatz kann helfen.",
    r_mid_meaning: "Die Aufblähung ist variabel: mit dem Arzt den Weg anpassen.",
    r_mid_steps_1: "<strong>FODMAP-arme Kost</strong> – möglichst begleitet.",
    r_mid_steps_2: "<strong>Gewohnheiten</strong> – trinken, langsam essen, Sprudel/Trigger begrenzen.",
    r_mid_steps_3: "<strong>Abklären</strong>, ob <strong>CDS22-<em>formula</em></strong> sinnvoll ist.",

    r_low_title: "Dein Blähbauch kann spezifische Ursachen haben.",
    r_low_meaning: "Hinweise auf Faktoren (Laktose, Obstipation, Aerophagie, Zyklus). Zielgerichtet angehen.",
    r_low_steps_1: "<strong>Muster beobachten</strong> – wann (Milch? schnelle Mahlzeiten? Menstruation?).",
    r_low_steps_2: "<strong>Gezielte Tests</strong> – 1–2 Wochen weniger Laktose, langsam kauen, Sprudel limitieren.",
    r_low_steps_3: "<strong>Bei Persistenz</strong> – spezifische Tests (Laktose/SIBO) mit Arzt besprechen.",

    r_note: "Hinweis: Die Ergebnisse sind informativ und ersetzen keine ärztliche Beratung.",
    r_right_title_ok: "Könnte passen:",
    r_right_title_maybe: "Mögliche Unterstützung:",

    p_450_name: "CDS22-formula 450B",
    p_450_dose: "1 Beutel pro Tag · 8–12 Wochen",
    p_450_b1: "Hohe Bakterienzahl",
    p_450_b2: "Gezielte Unterstützung in symptomatischen Phasen",

    p_112_name: "CDS22-formula 112B",
    p_112_dose: "1–2 Kapseln pro Tag · 8–12 Wochen",
    p_112_b1: "Für den täglichen Gebrauch",
    p_112_b2: "Mikrobiota-Support und Komfort nach Mahlzeiten",

    p_badges_array: ["✓ Vegetarisch","✓ Ohne Konservierungsstoffe","✓ Glutenfrei","✓ Nicht-GVO"]
  }
};

/* ===== Links multilingua ===== */
const PRODUCT_LINKS = {
  "450B": {
    en: "https://drdesimone.net/products/cds22-formula-450b",
    de: "https://drdesimone.net/de/products/cds22-formula-450b",
    es: "https://drdesimone.net/es/products/cds22-formula-450b",
    it: "https://drdesimone.net/products/cds22-formula-450b", // fallback EN
    fr: "https://drdesimone.net/products/cds22-formula-450b"  // fallback EN
  },
  "112B": {
    en: "https://drdesimone.net/products/cds22-formula-112b",
    de: "https://drdesimone.net/products/cds22-formula-112b",
    es: "https://drdesimone.net/es/products/cds22-formula-112b",
    it: "https://drdesimone.net/products/cds22-formula-112b", // fallback EN
    fr: "https://drdesimone.net/products/cds22-formula-112b"  // fallback EN
  }
};

/* Tracking chart (diario): IT = link esistente; EN/DE/ES = file inglese; FR fallback EN */
const DIARY_LINKS = {
  it: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Weekly_Health_Tracking_Chart-2.pdf?v=1757351789",
  en: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Weekly_Health_Tracking_Chart_EN.pdf?v=1762442793",
  de: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Weekly_Health_Tracking_Chart_EN.pdf?v=1762442793",
  es: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Weekly_Health_Tracking_Chart_EN.pdf?v=1762442793",
  fr: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Weekly_Health_Tracking_Chart_EN.pdf?v=1762442793"
};

/* ===== Funzione i18n ===== */
function setQuizLang(lang){
  const root = document.getElementById('cds22-quiz');
  const L = I18N[lang] || I18N.en;
  document.documentElement.setAttribute('lang', lang);
  document.documentElement.dataset.quizLang = lang;

  // Testi statici marcati
  root.querySelectorAll('[data-i18n]').forEach(el=>{
    const key = el.getAttribute('data-i18n');
    if (L[key] !== undefined){
      if (typeof L[key] === 'string' && /<\/?[a-z][\s\S]*>/i.test(L[key])) el.innerHTML = L[key];
      else el.textContent = L[key];
    }
  });

  // Titolo documento
  if (L.page_title) document.title = L.page_title;

  // Diario: link per lingua
  const dl = document.getElementById('diaryLink');
  if (dl) dl.href = DIARY_LINKS[lang] || DIARY_LINKS.en;

  // Prepara prodotti localizzati
  window.I18N_PRODUCTS = {
    "450B": {
      name: L.p_450_name, dose: L.p_450_dose, bullets: [L.p_450_b1, L.p_450_b2],
      link: (PRODUCT_LINKS["450B"][lang] || PRODUCT_LINKS["450B"].en)
    },
    "112B": {
      name: L.p_112_name, dose: L.p_112_dose, bullets: [L.p_112_b1, L.p_112_b2],
      link: (PRODUCT_LINKS["112B"][lang] || PRODUCT_LINKS["112B"].en)
    },
    badgesArray: L.p_badges_array || I18N.en.p_badges_array
  };

  // Se già visibile un risultato → ricalcola
  if (!root.querySelector('#res').classList.contains('hide')) {
    if (typeof calc === 'function') calc();
  }
}

/* Auto-detect: ?lang, path (/it|/es|/fr|/de), Shopify.locale */
(function(){
  const urlLang = new URLSearchParams(location.search).get('lang');
  const shopLang = window.Shopify && Shopify.locale ? Shopify.locale : null;
  const pathLang = /^\/(it|en|es|fr|de)\b/i.test(location.pathname) ? location.pathname.split('/')[1].toLowerCase() : null;
  const from = (urlLang || pathLang || shopLang || 'en').toLowerCase();
  const initial = (['it','en','es','fr','de'].includes(from) ? from : (from.startsWith('it')?'it':from.startsWith('es')?'es':from.startsWith('fr')?'fr':from.startsWith('de')?'de':'en'));
  setQuizLang(initial);
  window.setQuizLang = setQuizLang;
})();

/* ===== Resto della logica del quiz ===== */
(function(){
  const root = document.getElementById('cds22-quiz');
  const form = root.querySelector('#multistep-form');
  const formSteps = Array.from(root.querySelectorAll('.step'));
  let currentStep = 0;

  function showStep(stepIndex){
    formSteps.forEach(step => step.classList.remove('active'));
    formSteps[stepIndex].classList.add('active');
    updateButtonState();
  }

  function validateCurrentStep(){
    const currentStepSection = formSteps[currentStep];
    if (currentStepSection.id === 'step-disclaimer') {
      return root.querySelector('#accept-terms').checked;
    }
    if (currentStepSection.id === 'step-stop') {
      const stopCheckboxes = root.querySelectorAll('.stopc');
      const noStopCheckbox = root.querySelector('#no-stopc');
      const anyStopChecked = Array.from(stopCheckboxes).some(c => c.checked);
      return anyStopChecked || noStopCheckbox.checked;
    }
    let allValid = true;
    const inputs = currentStepSection.querySelectorAll('input[required], select[required]');
    inputs.forEach(input => { if (!input.value) allValid = false; });
    const radios = Array.from(currentStepSection.querySelectorAll('input[type="radio"]'));
    const radioNames = new Set(radios.map(r => r.name));
    radioNames.forEach(name => {
      if (!root.querySelector(`input[name="${name}"]:checked`)) allValid = false;
    });
    return allValid;
  }

  function updateButtonState(){
    const currentStepSection = formSteps[currentStep];
    let nextButton = currentStepSection.querySelector('.btn-primary');
    if (!nextButton && currentStepSection.id === 'step-risultato') {
      const resultButtons = currentStepSection.querySelectorAll('.btn-primary');
      nextButton = resultButtons[resultButtons.length - 1];
    }
    if (!nextButton) return;
    if (validateCurrentStep()) nextButton.classList.add('btn-ready');
    else nextButton.classList.remove('btn-ready');
  }

  window.nextStep = function(){
    const currentStepSection = formSteps[currentStep];
    if (!validateCurrentStep()) {
      const errorMsgId =
        currentStepSection.id === 'step-domande-b' ? 'domande-b-error' :
        currentStepSection.id === 'step-domande-c' ? 'domande-c-error' : '';
      if (errorMsgId) root.querySelector('#' + errorMsgId).classList.remove('hide');
      return;
    } else {
      const errorMsgId =
        currentStepSection.id === 'step-domande-b' ? 'domande-b-error' :
        currentStepSection.id === 'step-domande-c' ? 'domande-c-error' : '';
      if (errorMsgId) root.querySelector('#' + errorMsgId).classList.add('hide');
    }

    if (currentStepSection.id === 'step-stop') {
      const anyStopChecked = Array.from(root.querySelectorAll('.stopc')).some(c => c.checked);
      if (anyStopChecked) {
        currentStep = formSteps.length - 1;
        showStep(currentStep);
        root.querySelector('#stopMsg').classList.remove('hide');
        root.querySelector('#res').classList.add('hide');
        root.querySelector('.no-print').classList.add('hide');
        return;
      }
    }

    if (currentStep < formSteps.length - 1) {
      currentStep++;
      showStep(currentStep);
    }
    if (currentStep === formSteps.length - 1) {
      calc();
    }
  };

  window.prevStep = function(){
    if (currentStep > 1) currentStep--;
    else if (currentStep === 1) currentStep = 0;
    showStep(currentStep);
  };

  function resetForm(){
    root.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false; cb.disabled = false; cb.parentElement.classList.remove('disabled-checkbox'); });
    root.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
    root.querySelector('#score').textContent = '0.0';
    root.querySelector('#classif').innerHTML = (I18N[document.documentElement.dataset.quizLang] || I18N.en).res_fill;
    root.querySelector('#res').classList.add('hide');
    root.querySelector('#stopMsg').classList.add('hide');
    root.querySelector('.no-print').classList.add('hide');
    root.querySelector('#accept-terms').checked = false;
  }

  window.goToStart = function(){ resetForm(); currentStep = 0; showStep(currentStep); };

  const RES = root.querySelector('#res');
  const CLASSIF = root.querySelector('#classif');
  const SCORE = root.querySelector('#score');
  const STOPMSG = root.querySelector('#stopMsg');

  const PRODUCTS = {
    "450B": {
      name: "CDS22-formula 450B",
      img: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Products_450.png?v=1745389541",
      link: PRODUCT_LINKS["450B"].en, /* sovrascritto da I18N_PRODUCTS */
      dose: "1 sachet daily · 8–12 weeks",
      bullets: ["High bacterial load","Targeted support in more symptomatic periods"]
    },
    "112B": {
      name: "CDS22-formula 112B",
      img: "https://cdn.shopify.com/s/files/1/0879/1523/3608/files/Products_112.png?v=1745389586",
      link: PRODUCT_LINKS["112B"].en,
      dose: "1–2 capsules daily · 8–12 weeks",
      bullets: ["Daily use and tolerability","Microbiota support and post-meal comfort"]
    }
  };

  function productCard(p){
    const badgesArray = (window.I18N_PRODUCTS?.badgesArray) || I18N.en.p_badges_array;
    const badges = badgesArray.map(s=>`<span>${s}</span>`).join('');
    return `
      <div class="product-card">
        <a href="${p.link}" target="_blank" rel="noopener">
          <img class="product-img" src="${p.img}" alt="${p.name}">
        </a>
        <div class="product-body">
          <div class="product-name">${p.name}</div>
          <p class="product-note">${p.dose}</p>
          <ul class="product-bullets">
            ${p.bullets.map(b=>`<li>${b}</li>`).join("")}
          </ul>
          <div class="product-cta">
            <a class="btn-cta" href="${p.link}" target="_blank" rel="noopener">Learn more</a>
            <div class="badges">${badges}</div>
          </div>
        </div>
      </div>
    `;
  }

  function renderResult(level, total){
    const lang = document.documentElement.dataset.quizLang || 'en';
    const L = I18N[lang] || I18N.en;

    let title="", meaning="", steps="", rightCard="";
    if(level==="high450"){
      title = L.r_ok_title;
      meaning = `<p>${L.r_ok_meaning_450}</p>`;
      steps = `<ol class="result-steps">
        <li>${L.r_ok_steps_450_1}</li>
        <li>${L.r_ok_steps_450_2}</li>
        <li>${L.r_ok_steps_450_3}</li>
      </ol>`;
      const P = window.I18N_PRODUCTS?.["450B"];
      const merged = P ? { ...PRODUCTS["450B"], name:P.name, dose:P.dose, bullets:P.bullets, link:P.link } : PRODUCTS["450B"];
      rightCard = productCard(merged);
    } else if(level==="high112"){
      title = L.r_ok_title;
      meaning = `<p>${L.r_ok_meaning_112}</p>`;
      steps = `<ol class="result-steps">
        <li>${L.r_ok_steps_112_1}</li>
        <li>${L.r_ok_steps_112_2}</li>
        <li>${L.r_ok_steps_112_3}</li>
      </ol>`;
      const P = window.I18N_PRODUCTS?.["112B"];
      const merged = P ? { ...PRODUCTS["112B"], name:P.name, dose:P.dose, bullets:P.bullets, link:P.link } : PRODUCTS["112B"];
      rightCard = productCard(merged);
    } else if(level==="mid"){
      title = L.r_mid_title;
      meaning = `<p>${L.r_mid_meaning}</p>`;
      steps = `<ol class="result-steps">
        <li>${L.r_mid_steps_1}</li>
        <li>${L.r_mid_steps_2}</li>
        <li>${L.r_mid_steps_3}</li>
      </ol>`;
      rightCard = "";
    } else {
      title = L.r_low_title;
      meaning = `<p>${L.r_low_meaning}</p>`;
      steps = `<ol class="result-steps">
        <li>${L.r_low_steps_1}</li>
        <li>${L.r_low_steps_2}</li>
        <li>${L.r_low_steps_3}</li>
      </ol>`;
      rightCard = "";
    }

    const rightTitle = (level==="high450"||level==="high112") ? L.r_right_title_ok : L.r_right_title_maybe;
    const note = `<p class='small'>${L.r_note}</p>`;

    const leftHTML = `
      <div class="result-main ${ level==="high450"||level==="high112" ? "ok" : level==="mid" ? "maybe" : "no"}">
        <div class="result-title">${title}</div>
        <div class="result-meaning">${meaning}</div>
        ${steps}
        <div class="result-actions">
          <button class="btn" onclick="printAll()">${L.btn_print}</button>
        </div>
        ${note}
      </div>`;

    const rightHTML = rightCard ? `
      <div class="result-side" style="--accent:${ (level==="high450"||level==="high112") ? "#2D2A7F" : (level==="mid" ? "#BEB8F3" : "#F875AA") }; --accentText:${ (level==="mid") ? "#1f2937" : "#FFFFFF" }">
        <div class="recommend-title">${rightTitle}</div>
        ${rightCard}
      </div>` : "";

    return `<div class="result-grid">${leftHTML}${rightHTML}</div>`;
  }

  function val(name){
    const el = root.querySelector(`input[name='${name}']:checked`);
    return el ? parseFloat(el.value) : 0;
  }

  function toLocaleScore(n){
    try { return n.toLocaleString(document.documentElement.lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); }
    catch { return n.toFixed(1); }
  }

  window.calc = function(){
    STOPMSG.classList.add('hide');
    RES.classList.remove('hide');
    RES.classList.remove('ok','maybe','no');
    root.querySelector('.no-print').classList.remove('hide');

    let sB = 0; for(let i=0;i<6;i++) sB += val('b'+i);
    let sC = 0; for(let i=0;i<5;i++) sC += val('c'+i);
    const total = sB + sC;

    SCORE.textContent = toLocaleScore(total);
    const L = I18N[document.documentElement.dataset.quizLang] || I18N.en;

    if (total >= 5){
      if (total >= 9) {
        CLASSIF.innerHTML = renderResult("high450", total);
        RES.classList.add('ok');
      } else {
        CLASSIF.innerHTML = renderResult("high112", total);
        RES.classList.add('ok');
      }
    } else if (total >= 3){
      CLASSIF.innerHTML = renderResult("mid", total);
      RES.classList.add('maybe');
    } else {
      CLASSIF.innerHTML = renderResult("low", total);
      RES.classList.add('no');
    }
  }

  window.printAll = function(){
    const allSteps = root.querySelectorAll('.step');
    root.querySelector('#refsModal').classList.remove('hide'); // mostra riferimenti in stampa
    allSteps.forEach(step => step.style.display = 'block');
    window.print();
    allSteps.forEach((step, index) => step.style.display = index === currentStep ? 'block' : 'none');
    root.querySelector('#refsModal').classList.add('hide');
  };

  /* Modal riferimenti */
  window.openRefsModal = function(){
    const m = document.getElementById('refsModal');
    m.classList.remove('hide');
    m.setAttribute('aria-hidden','false');
    const escHandler = (e)=>{ if(e.key==='Escape'){ window.closeRefsModal(); } };
    document.addEventListener('keydown', escHandler, { once:true });
    const onBg = (e)=>{ if(e.target === m){ window.closeRefsModal(); m.removeEventListener('click', onBg); } };
    m.addEventListener('click', onBg);
  };
  window.closeRefsModal = function(){
    const m = document.getElementById('refsModal');
    m.classList.add('hide');
    m.setAttribute('aria-hidden','true');
  };

  // Logica mutuale tra "nessun segnale" e segnali d'allarme
  const stopCheckboxes = root.querySelectorAll('.stopc');
  const noStopCheckbox = root.querySelector('#no-stopc');

  noStopCheckbox.addEventListener('change', function(){
    const isChecked = this.checked;
    stopCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
      checkbox.disabled = isChecked;
      checkbox.parentElement.classList.toggle('disabled-checkbox', isChecked);
    });
    updateButtonState();
  });
  stopCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function(){
      const anyStopChecked = Array.from(stopCheckboxes).some(c => c.checked);
      noStopCheckbox.checked = false;
      noStopCheckbox.disabled = anyStopChecked;
      noStopCheckbox.parentElement.classList.toggle('disabled-checkbox', anyStopChecked);
      updateButtonState();
    });
  });

  // Eventi
  form.addEventListener('input', updateButtonState);
  root.querySelector('#accept-terms').addEventListener('change', updateButtonState);

  // Init
  showStep(currentStep);
})();